__turbopack_context__.v({
  "bandHeader": "_8hR93W_bandHeader",
  "card": "_8hR93W_card",
  "earnBuzzCard": "_8hR93W_earnBuzzCard",
  "earnCard": "_8hR93W_earnCard",
  "getPaidCard": "_8hR93W_getPaidCard",
  "highlightCard": "_8hR93W_highlightCard",
  "highlightCardBackgroundIcon": "_8hR93W_highlightCardBackgroundIcon",
  "highlightColor": "_8hR93W_highlightColor",
  "mantine-Title-root": "_8hR93W_mantine-Title-root",
  "newPerksCard": "_8hR93W_newPerksCard",
  "programBand": "_8hR93W_programBand",
  "section": "_8hR93W_section",
});
